<p-fileUpload name="file-upload[]"
  (uploadHandler)="uploadFiles($event)"
  (onSelect)="onSelect($event)"
  multiple="true"
  [auto]="true"
  [chooseLabel]="'app_upload_attachment' | i18next"
  customUpload="true">
  <ng-template pTemplate="toolbar">
    <div class="font-small">{{ "support_attachment_file_info" | i18next: { maxLength: maxFileLength, maxSize: (maxFileSize | formatByteSize) } }}</div>
  </ng-template>
  <ng-template let-file pTemplate="file"></ng-template>
  <ng-template pTemplate="content">
    @if (attachedFiles.length) {
      <div>
        @for (f of attachedFiles; track f; let i = $index) {
          <div class="p-fileupload-row font-small">
            @if (f.file && f.file.objectURL && isImage(f.file)) {
              <div><img [src]="f.file.objectURL" width="50px" /></div>
            }
            @if (f.file && !isImage(f.file)) {
              <div class="text-right">
                <i class="fas fa-paperclip"></i>
              </div>
            }
            @if (f.file) {
              <div>{{f.file.name}}</div>
            }
            @if (f.file) {
              <div>{{ f.file.size | formatByteSize }}</div>
            }
            @if (f.file) {
              <div>
                @if (!isUploadDone(i) && getFileProgress(i) > 0) {
                  <span>{{ getFileProgress(i) }}%</span>
                }
                @if (isUploadDone(i)) {
                  <button type="button" icon="pi pi-times" pButton (click)="removeFile(i)"></button>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </ng-template>
</p-fileUpload>



